import { DeviceType } from '../common';
import { AssetGroupStatus } from './asset-group.model';
import { DeviceStatusName } from './device.model';
import { AssetStatusName } from './enums';

export enum DisplayMode {
  DRAWER = 'DRAWER',
  PAGE = 'PAGE'
}

export interface AssetGroupOfAssociationByAsset {
  id: string;
  name: string;
  status: AssetGroupStatus;
  hiddenAssetsCount: number;
  assets: AssetOfAssociationByAsset[];
}

export interface AssetOfAssociationByAsset {
  id: string;
  name: string;
  status: { name: AssetStatusName };
  priority?: number;
  dispatch: { shipTo: string | null };
  hiddenDevicesCount: number;
  imageUrl: string | null;
  product1: { name: string } | null;
  product2: { name: string } | null;
  devices: DeviceOfAssociationByAsset[];
}

export interface DeviceOfAssociationByAsset {
  id: string;
  name: string;
  status: { name: DeviceStatusName };
  imageUrl: string | null;
  type: DeviceType;
}

export interface AssociationByAsset {
  assetGroups: AssetGroupOfAssociationByAsset[];
  assets: AssetOfAssociationByAsset[];
  devices: DeviceOfAssociationByAsset[];
}
